module.exports = __webpack_public_path__ + "img/jpm_icons4.a36a682e.svg";